import React, { useState, createContext, useEffect, useContext } from "react";

import { fetchAdminApi } from "../utils/apiCalls";
import { useAuth } from "../firebase";

const InternalAdminContext = createContext();
export { InternalAdminContext };

const InternalAdminContextProvider = ({ children }) => {
  const [user, userLoading] = useAuth();

  const [isAdminCheckLoading, setIsAdminCheckLoading] = useState(true);
  const [isUserAclymateAdmin, setIsUserAclymateAdmin] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState({});
  const [selectableCompanies, setSelectableCompanies] = useState([]);

  useEffect(() => {
    const checkIfUserIsAclymateAdmin = async () => {
      if (!user) {
        setIsAdminCheckLoading(false);
        return;
      }

      const { claims } = await user.getIdTokenResult({ forceRefresh: true });
      const { isAclymateAdmin = false } = claims;

      setIsUserAclymateAdmin(isAclymateAdmin);
      setIsAdminCheckLoading(false);
    };

    if (!userLoading) {
      checkIfUserIsAclymateAdmin();
    }
  }, [user, userLoading]);

  useEffect(() => {
    const fetchAndSetSelectableCompanies = async () => {
      const allCompanies = await fetchAdminApi({
        user,
        url: "/aclymate/fetch-all-companies-names-and-ids",
        data: { method: "GET" }
      });

      const allCompaniesWithNames = allCompanies
        .filter(({ name }) => !!name)
        .map(({ name, id }) => ({
          name: `${name} (${id})`,
          id
        }));

      return setSelectableCompanies(allCompaniesWithNames);
    };

    if (isUserAclymateAdmin) {
      fetchAndSetSelectableCompanies();
    }
  }, [isUserAclymateAdmin, user]);

  return (
    <InternalAdminContext.Provider
      value={{
        user,
        userLoading,
        isAdminCheckLoading,
        isUserAclymateAdmin,
        selectedCompany,
        setSelectedCompany,
        selectableCompanies
      }}
    >
      {children}
    </InternalAdminContext.Provider>
  );
};

export const useInternalAdminContext = () => useContext(InternalAdminContext);
export default InternalAdminContextProvider;
